import {
  IEmergePayTransaction,
  ProcessingFeeHandlingTypeEnum
} from '@/services/types/TransactionData';
import React from 'react';
import CurrencyFormat from 'react-currency-format';

export const getEmergePaySubtext = (transactionData: IEmergePayTransaction) => {
  return (
    <span className="text-emerge-navy-2 flex flex-row gap-x-1">
      <CurrencyFormat
        id="currency"
        value={Number(transactionData.processingFee).toFixed(2)}
        displayType={'text'}
        thousandSeparator={true}
        prefix={'$'}
        decimalScale={2}
      />
      {transactionData.processingFeeHandlingType === ProcessingFeeHandlingTypeEnum.Customer
        ? 'Excluded customer fee'
        : 'Included fee'}
    </span>
  );
};
